import styled from "styled-components";

export const Container = styled.div`
  background-color: #f8f8f8;
  padding: 20px;
`;

export const ComponentType = styled.h3`
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 300;
  margin: 0;
`;

export const InputTitle = styled.input`
  width: 100%;
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  margin-bottom: 5px;
  height: 40px;
  border: none;
  color: black;
  padding: 10px;
  &:focus {
    border: none;
    outline: none;
  }
`;

export const InputDescription = styled.textarea`
  width: 100%;
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 300;
  line-height: 19px;
  margin-bottom: 5px;
  /* height: 40px; */
  border: none;
  color: black;
  padding: 10px;
  &:focus {
    border: none;
    outline: none;
  }
`;

export const InputFile = styled.label`
  width: 100%;
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 300;
  border: none;
  &:focus {
    outline: none;
    border: none;
  }
`;
